import { defineMessages } from 'react-intl';

const scope = 'cb.screens.PaymentForm';

export default defineMessages({
  plusTax: {
    id: `${scope}.plusTax`,
    defaultMessage: 'plus Tax',
  },
  invalidCardNumber: {
    id: `${scope}.invalidCardNumber`,
    defaultMessage: 'Invalid card number',
  },
  invalidCardCVC: {
    id: `${scope}.invalidCardCVC`,
    defaultMessage: 'Invalid card CVC',
  },
  invalidMonthYear: {
    id: `${scope}.invalidMonthYear`,
    defaultMessage: 'Invalid month year',
  },
  cardNumberPlaceholder: {
    id: `${scope}.cardNumberPlaceholder`,
    defaultMessage: 'Card number',
  },
  cardMonthYearPlaceholder: {
    id: `${scope}.cardMonthYearPlaceholder`,
    defaultMessage: 'MM / YY',
  },
  cardCVCPlaceholder: {
    id: `${scope}.cardCVCPlaceholder`,
    defaultMessage: 'CVC',
  },
  fullYearMembership: {
    id: `${scope}.fullYearMembership`,
    defaultMessage: 'Full Year Membership',
  },
  donatedTo: {
    id: `${scope}.donatedTo`,
    defaultMessage: '100% of proceeds are donated to;',
  },
  paymentInformation: {
    id: `${scope}.paymentInformation`,
    defaultMessage: 'Payment Information',
  },
  backBtn: {
    id: `${scope}.backBtn`,
    defaultMessage: 'Back',
  },
  payBtn: {
    id: `${scope}.payBtn`,
    defaultMessage: 'Pay now',
  },
  premiumDetails: {
    id: `${scope}.premiumDetails`,
    defaultMessage: 'You are purchasing a one year premium membership.',
  },
  paymentSummary: {
    id: `${scope}.paymentSummary`,
    defaultMessage: 'Payment Summary',
  },
  cancelBtn: {
    id: `${scope}.cancelBtn`,
    defaultMessage: 'Cancel',
  },
  costField: {
    id: `${scope}.costField`,
    defaultMessage: 'Cost',
  },
  totalField: {
    id: `${scope}.totalField`,
    defaultMessage: 'Total',
  },
  free: {
    id: `${scope}.continueWithFreePlan`,
    defaultMessage: 'Continue with free plan',
  },
  paymentError: {
    id: `${scope}.paymentError`,
    defaultMessage: "Sorry, we can't process your payment",
  },
});
